import { render, staticRenderFns } from "./Localisations.vue?vue&type=template&id=4d33a7a5&scoped=true&"
import script from "./Localisations.vue?vue&type=script&lang=js&"
export * from "./Localisations.vue?vue&type=script&lang=js&"
import style0 from "./Localisations.vue?vue&type=style&index=0&id=4d33a7a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33a7a5",
  null
  
)

export default component.exports